module.exports = __webpack_public_path__ + "img/ico_rule.61866794.svg";